/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type { Benis, BenisInterface } from "../../contracts/Benis";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IBEP20",
        name: "_wban",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_wbanPerSecond",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "_startTime",
        type: "uint32",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "EmergencyWithdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "pid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "_allocPoint",
        type: "uint16",
      },
      {
        internalType: "contract IBEP20",
        name: "_stakingToken",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_withUpdate",
        type: "bool",
      },
    ],
    name: "add",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "addSeconds",
        type: "uint32",
      },
    ],
    name: "changeEndTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
    ],
    name: "emergencyWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "endTime",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_from",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_to",
        type: "uint256",
      },
    ],
    name: "getMultiplier",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "massUpdatePools",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "pendingWBAN",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "poolInfo",
    outputs: [
      {
        internalType: "contract IBEP20",
        name: "stakingToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "stakingTokenTotalAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "accWBANPerShare",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "lastRewardTime",
        type: "uint32",
      },
      {
        internalType: "uint16",
        name: "allocPoint",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "poolLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "_allocPoint",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "_withUpdate",
        type: "bool",
      },
    ],
    name: "set",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_wbanPerSecond",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_withUpdate",
        type: "bool",
      },
    ],
    name: "setWBANPerSecond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "startTime",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalAllocPoint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
    ],
    name: "updatePool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "userInfo",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "rewardDebt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "remainingWBANReward",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "wban",
    outputs: [
      {
        internalType: "contract IBEP20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "wbanPerSecond",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type BenisConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BenisConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Benis__factory extends ContractFactory {
  constructor(...args: BenisConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _wban: PromiseOrValue<string>,
    _wbanPerSecond: PromiseOrValue<BigNumberish>,
    _startTime: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Benis> {
    return super.deploy(
      _wban,
      _wbanPerSecond,
      _startTime,
      overrides || {}
    ) as Promise<Benis>;
  }
  override getDeployTransaction(
    _wban: PromiseOrValue<string>,
    _wbanPerSecond: PromiseOrValue<BigNumberish>,
    _startTime: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _wban,
      _wbanPerSecond,
      _startTime,
      overrides || {}
    );
  }
  override attach(address: string): Benis {
    return super.attach(address) as Benis;
  }
  override connect(signer: Signer): Benis__factory {
    return super.connect(signer) as Benis__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BenisInterface {
    return new utils.Interface(_abi) as BenisInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Benis {
    return new Contract(address, _abi, signerOrProvider) as Benis;
  }
}
